export const status = {
  pending: {
    name: 'Pendiente',
    color: 'warning',
  },
  inProgress: {
    name: 'En progreso',
    color: 'info',
  },
  done: {
    name: 'Finalizado',
    color: 'success',
  },
}

export const relevance = {
  low: {
    name: 'Baja',
    color: 'success',
  },
  medium: {
    name: 'Media',
    color: 'warning',
  },
  high: {
    name: 'Alta',
    color: 'error',
  }
}

export const tipos = [
  {
    value: 'sugerencia',
    label: 'Sugerencia'
  },
  {
    value: 'arreglo',
    label: 'Arreglo'
  },
  {
    value: 'problema',
    label: 'Problema'
  },
];

export const suggestions = [
  {
    id: 1,
    date: '2023-11-01',
    title: 'Sugerencia 1',
    description: 'Lorem ipsum dolor sit amet',
    status: status.pending,
    relevance: relevance.low,
  },
  {
    id: 2,
    date: '2023-11-01',
    title: 'Sugerencia 2',
    description: 'Lorem ipsum dolor sit amet',
    status: status.inProgress,
    relevance: relevance.medium,
  }
]

export const fixes = [
  {
    id: 1,
    date: '2023-11-01',
    title: 'Arreglo 1',
    description: 'Lorem ipsum dolor sit amet',
    status: status.done,
    relevance: relevance.low,
  }
]

export const issues = [
  {
    id: 1,
    date: '2023-11-01',
    title: 'Problema 1',
    description: 'Lorem ipsum dolor sit amet',
    status: status.inProgress,
    relevance: relevance.high,
  }
]